"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_PLAY_ANIMATION_VALUE = 'SET_PLAY_ANIMATION_VALUE';
exports.RESET_PLAY_ANIMATION_VALUE = 'RESET_PLAY_ANIMATION_VALUE';



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/animation-playing/types.ts
// module id = 370
// module chunks = 5